import { render, staticRenderFns } from "./FWMLv2PolicyViz.vue?vue&type=template&id=f20b30dc"
import script from "./FWMLv2PolicyViz.vue?vue&type=script&lang=js"
export * from "./FWMLv2PolicyViz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports